import { create } from 'zustand';

type Borrower1003Store = {
  selectedBorrowerId: number | null;
  setSelectedBorrowerId: (borrowerId: number | null) => void;
};

export const useBorrower1003Store = create<Borrower1003Store>((set) => ({
  selectedBorrowerId: null,
  setSelectedBorrowerId: (borrowerId) => {
    set({ selectedBorrowerId: borrowerId });
  },
}));
